export default __webpack_public_path__ + "assets/media/13-12-1025-4-1004925-main.jpg";